<template>
<div class="card" v-if="selecteaza_inginer">
      <div class="card-header">
        <p style="display: inline;">{{titlu}}</p> 
      </div>
      <div class="card-body">
        
        <div class="dropdown" style="width: 100%;">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" style="width: 100%;">
                {{selected.user__first_name}} {{selected.user__last_name}}
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style="width: 100%;" @click="sterge_filtru">
                <input type="search" class="form-control search" placeholder="Selecteaza..." autofocus="autofocus"
                @keyup="filter_($event.target.value.toUpperCase());">
                <li><a class="dropdown-item inginer_item" v-for="ing in ingineri" v-bind:key="ing.id" href="#"
                      @click="selecteaza(ing)">{{ing.user__first_name}} {{ing.user__last_name}}</a></li>
            </ul>
        </div>
      </div>
      <div class="card-footer">
        <button class="btn btn-primary float-left" v-if="selectat" style="width:130px;" @click='aplica'>{{buton_aplica}}</button>
        <button class="btn btn-warning float-right" style="width:130px;" @click='hide'>Uita</button>
      </div>      
</div> 

</template>


<script>

export default {
    name: 'SelectInginer',
    data () {
        return {
            selected: {id: null, user__first_name: "----"},
            selectat: false,
            buton_aplica: 'Trimite'
        }
    },
    props:["ingineri", "titlu", "inginer", "selecteaza_inginer"],
    methods:{
        selecteaza: function(ing){
            this.selected = ing
            this.selectat = true
            //this.$emit('inginer_selectat', ing)
        },
        filter_ : function(filtru){
            var b = document.getElementsByClassName("inginer_item");
            for( var i =0; i< b.length; i++){ 
                b[i].style.display = b[i].textContent.toUpperCase().indexOf(filtru) > -1 ? "" : "none";
            }
        },
        sterge_filtru: function(){
            this.cauta_inginer= '';
            this.filter_(this.cauta_inginer);
        },

        aplica : function(){
           this.$emit('inginer_confirmare', this.selected);
        },

        hide: function(){
            this.$emit('uita_inginer_selectat');
        }
           
    }
}
</script>